import { Car, ClipboardList, Users } from "lucide-react";
import { Logo } from "@/components/brand/logo";

const features = [
  {
    icon: Users,
    title: "Müşteri & Araç Kartları",
    desc: "Her müşterinin aracını plaka, şasi no, motor no ve kilometre bilgisiyle tek yerde arşivle.",
  },
  {
    icon: ClipboardList,
    title: "Servis Geçmişi",
    desc: "Araca yapılan her işlem tarih, maliyet ve açıklamalarıyla kayıt altında.",
  },
  {
    icon: Car,
    title: "Parça Tedarik Takibi",
    desc: "Hangi araca hangi parça, hangi tedarikçiden, kaç liraya alındı tek bakışta tümünü gör.",
  },
];

export function BrandPanel() {
  return (
    <div className="relative hidden overflow-hidden border-r border-ink-200/70 bg-white lg:flex lg:w-1/2 lg:flex-col">
      {/* Soft amber/orange glow accents (dashboard ile aynı dil) */}
      <div className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full bg-brand-200/50 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-40 -left-24 h-96 w-96 rounded-full bg-orange-200/40 blur-3xl" />

      <div className="relative z-10 flex h-full flex-col justify-between p-12">
        <Logo tone="dark" size="xl" to="/" />

        <div className="max-w-md space-y-8">
          <div className="space-y-3">
            <h2 className="text-balance text-4xl font-bold leading-tight tracking-tight text-ink-900">
              Atölyenin dijital arşivi,
              <br />
              <span className="bg-gradient-to-r from-brand-500 to-brand-700 bg-clip-text text-transparent">
                tek panelde.
              </span>
            </h2>
            <p className="text-balance text-base leading-relaxed text-ink-600">
              Defter karıştırmaya son!
              <br />
              Hangi araç ne zaman geldi, ne işlem yapıldı, hangi parça takıldı
              hepsini saniyeler içinde bul.
            </p>
            <p className="text-balance text-base leading-relaxed text-ink-600"></p>
          </div>
          <ul className="space-y-5">
            {features.map((f) => (
              <li key={f.title} className="flex gap-3">
                <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-ink-200/70 bg-white text-brand-600 shadow-sm">
                  <f.icon className="h-4 w-4" />
                </div>
                <div>
                  <div className="font-medium text-ink-900">{f.title}</div>
                  <div className="mt-0.5 text-sm text-ink-500">{f.desc}</div>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="text-xs text-ink-500">
          © {new Date().getFullYear()} Ustorio
        </div>
      </div>
    </div>
  );
}
